export default "__VITE_ASSET__ooVoOAl0__"